import * as React from "react";

const SvgYellowCard = props => <svg width={19} height={24} viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.8676 0.25H0.446899V23.75H9.65724H18.8676V12V0.25Z" fill="#F1E94E" /></svg>;

export default SvgYellowCard;